<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @viewQrCode="viewQrCode"
      @openEditDialog="openEditDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        @openEditDialog="openEditDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="700px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :versionCode="editFormDialogOptions.code"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      v-if="qrOptions.qrVisible"
      :visible.sync="qrOptions.qrVisible"
      model-value
      show-close
      width="500px"
      :title="$l('dialog_title_download_qr') || '下载二维码'"
      :close-on-click-modal="false"
      :before-close="() => (qrOptions.qrVisible = false)"
      append-to-body
      draggable
    >
      <div style="padding: 30px;">
        <div style=" border-radius: 2px;">
          <img
            fit="fit"
            style="width: 100%; height: 100%"
            alt="QR Code"
            :src="qrOptions.qrCode"
          />
        </div>
        <div
          style=" font-size: 15px;  display: flex; justify-content: center;  align-items: center;margin-bottom: 10px;font-weight: 700;"
        >
          <div>
            {{ $l('version_name') || '合祥产线报工 v'
            }}{{ qrOptions.versionName }}
          </div>
        </div>
        <div
          style="display: flex; justify-content: center;  align-items: center;  background-color:#59ba15; border-radius: 5px;height: 40px; "
          @click="downloadApp"
        >
          <div class="mr-2">
            <i class="el-icon-download" style="color:#FFFFFF;"></i>
          </div>
          <div style="font-size: 15px;color:#FFFFFF;">
            <div>{{ $l('dialog_android_dow') || 'Android 下载' }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import BasePage from '@/mixins/base-pagination'
import EditForm from '../edit-form'
export default {
  components: { PageHeader, PageMain, EditForm },
  mixins: [BaseTable, BasePage],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: { visible: false, code: '' },
      qrOptions: { qrVisible: false, qrCode: '', downloadUrl: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .appVersionRecordsListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, versionCode = '' }) {
      const types = {
        edit: this.$l('dialog_title_edit') || '编辑PAD应用版本',
        add: this.$l('dialog_title_add') || '添加PAD应用版本',
        detail: this.$l('dialog_title_detail') || 'PAD应用版本详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: versionCode,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },

    async viewQrCode({ versionCode, downloadUrl, versionName }) {
      this.loading = true
      const res = await this.$api
        .appVersionRecordsQrCodeApi({ versionCode })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.qrOptions.qrCode = 'data:image/png;base64,' + res.body
      this.qrOptions.downloadUrl = downloadUrl
      this.qrOptions.qrVisible = true
      this.qrOptions.versionName = versionName
    },
    downloadApp() {
      window.open(this.qrOptions.downloadUrl)
    },
  },
}
</script>
